export default __webpack_public_path__ + "static/media/remainder.238a6c3a.svg";